// Map a capture-option "book" (INTENT_MLKIT_LABEL_RULES etc.) into the option
// cards the playground's Intention page renders — split out of PlaygroundView so
// that component file exports ONLY its component (react-refresh/only-export-components).
//
// `fallback` (Identify) appended LAST — the same ordering the app uses. Each
// card carries the option's `prompt` VERBATIM (the book's contract: it both
// triggers the owning skill and instructs the photo task).
export function mapBookToOptionCards(book) {
  const opts = Array.isArray(book?.options) ? book.options : [];
  const toCard = (o) => ({
    icon: o.icon,
    title: o.title,
    prompt: o.prompt, // verbatim sent text — handleStartSession sends as-is
    slug: o.slug,
    skill: o.skill, // doc-only; informational
  });
  const cards = opts.map(toCard);
  if (book?.fallback && book.fallback.title) cards.push(toCard(book.fallback));
  return cards;
}
